import { Pagination } from "antd";
import { useTranslation } from "react-i18next";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

interface PaginationProps {
  total: number;
  active: number;
  itemPerPage: number;
  setActive: (value: number) => void;
  scroll?: () => void;
  pageSizeOptions?: number[];
  onPageSizeChange?: (value: number) => void;
}
const PaginationComponent = ({
  total,
  active,
  setActive,
  itemPerPage,
  scroll,
  pageSizeOptions,
  onPageSizeChange,
}: PaginationProps) => {
  const { t, i18n } = useTranslation();
  const showSizeDropdown =
    Array.isArray(pageSizeOptions) &&
    pageSizeOptions.length > 0 &&
    typeof onPageSizeChange === "function";
  const itemRender = (page: any, type: any, originalElement: any) => {
    if (type === "prev") {
      return (
        <a aria-label="Previous" className="ac--pagination-arrow">
          <span aria-hidden="true">
            {i18n.language === "ar" ? (
              <IoIosArrowForward />
            ) : (
              <IoIosArrowBack />
            )}
          </span>
        </a>
      );
    }
    if (type === "next") {
      return (
        <a aria-label="Next" className="ac--pagination-arrow">
          <span aria-hidden="true">
            {i18n.language === "ar" ? (
              <IoIosArrowBack />
            ) : (
              <IoIosArrowForward />
            )}
          </span>
        </a>
      );
    }

    return originalElement;
  };

  return (
    <div className="ac--pagination-container">
      {showSizeDropdown ? (
        <div className="ac--pagination-size">
          <span className="text-xs-medium neutral-500 ac--pagination-size__label">
            {t("services.perPage")}
          </span>
          <div className="item-sort border-1">
            <div className="dropdown dropdown-sort border-1-right">
              <button
                className="btn dropdown-toggle"
                id="dropdownPageSize"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                aria-label={t("services.perPage")}
              >
                <span>{itemPerPage}</span>
              </button>
              <ul
                className="dropdown-menu dropdown-menu-light m-0"
                aria-labelledby="dropdownPageSize"
              >
                {pageSizeOptions.map((size) => (
                  <li className="hover-white" key={size}>
                    <a
                      className={`dropdown-item ${
                        itemPerPage === size ? "active" : ""
                      }`}
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        if (size !== itemPerPage) onPageSizeChange(size);
                      }}
                    >
                      {size}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ) : null}
      {total > itemPerPage ? (
        <Pagination
          current={active}
          total={total}
          pageSize={itemPerPage}
          onChange={setActive}
          itemRender={itemRender}
          showSizeChanger={false}
        />
      ) : null}
    </div>
  );
};

export default PaginationComponent;
